import { User, UserFormValues } from '../../user/models/user';
import apiClient from '../../../core/Api';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const login = async (username: string, password: string): Promise<User> =>
  apiClient
    .post(`${API_BASE_URL}/admin/sessions`, { usernameOrEmail: username, password })
    .then((response) => response.data.user);

const signup = async (params: UserFormValues): Promise<User> =>
  apiClient.post(`${API_BASE_URL}/signup`, { ...params }).then((response) => response.data.user);

const isLoggedIn = async (): Promise<any> =>
  apiClient.get(`${API_BASE_URL}/is_logged_in`).then((response) => response.data);

const logout = async (): Promise<any> => {
  return apiClient.delete(`${API_BASE_URL}/admin/sessions`).then((response) => response.data);
};

const forgotPassword = async (email: string): Promise<any> =>
  apiClient.post(`${API_BASE_URL}/users/forgot-password`, { usernameOrEmail: email }).then((response) => {
    return response.data;
  });

const resetPassword = async (token: string, password: string): Promise<{ user: User; token: string }> =>
  apiClient
    .post(`${API_BASE_URL}/users/password`, { passwordResetToken: token, newPassword: password })
    .then((response) => {
      return response.data;
    });

export { login, signup, logout, isLoggedIn, forgotPassword, resetPassword };
